import { Loader2 } from 'lucide-react';

import {
  TABS_TRIGGER_CLASS_NAME,
  tabsListVariants,
} from '@/components/ui/tabs';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type SegmentedToggleOption = {
  value: string;
  label: string;
};

type SegmentedToggleProps = {
  label: string;
  options: SegmentedToggleOption[];
  value: string;
  pendingValue?: string | null;
  onValueChange: (value: string) => void;
};

export const SegmentedToggle = (props: SegmentedToggleProps) => {
  const { label, options, value, pendingValue = null, onValueChange } = props;
  const isPending = pendingValue !== null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          role="group"
          aria-label={label}
          data-variant="segmented"
          className={tabsListVariants({ variant: 'segmented' })}
        >
          {options.map((option) => {
            const isCurrent = option.value === value;

            return (
              <button
                key={option.value}
                type="button"
                aria-pressed={isCurrent}
                data-state={isCurrent ? 'active' : 'inactive'}
                disabled={isPending}
                className={TABS_TRIGGER_CLASS_NAME}
                onClick={
                  isCurrent ? undefined : () => onValueChange(option.value)
                }
              >
                {option.value === pendingValue && (
                  <Loader2 className="animate-spin" />
                )}
                {option.label}
              </button>
            );
          })}
        </div>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
};
